import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  ViewChild,
} from "@angular/core";
import { QPilotScheduledOrder } from "../types/scheduled-order";
import { catchError, of, tap } from "rxjs";
import { QPilotCloudApiService } from "../../services/qpilot-cloud-api.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DataService } from "../../services/data.service";
import { errorSnackBar, successSnackBar } from "../../utils";
import { CommonModule } from "@angular/common";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "lib-add-note",
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: "./add-note.component.html",
  styleUrl: "./add-note.component.scss",
})
export class AddNoteComponent {
  @Input() order: QPilotScheduledOrder;
  @Input() canUpdateNotes: boolean = false;
  originalNote?: string;

  @ViewChild("autosize") autosize: CdkTextareaAutosize;

  constructor(
    private qPilotCloudApiService: QPilotCloudApiService,
    private dataService: DataService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.originalNote = this.order?.note;
  }

  onCancel() {
    this.order.note = this.originalNote;
  }

  onUpdate() {
    this.qPilotCloudApiService
      .updateScheduledOrder(this.order)
      .pipe(
        tap((order) => {
          this.originalNote = this.order?.note;
          this.dataService.updateOrder(order);
        }),
        tap(() => successSnackBar(this.snackBar, "Update: Note Changed")),
        catchError((response) => {
          errorSnackBar(
            this.snackBar,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            `Update Failed: ${response?.error?.messages?.userMessage[0] ?? "Error Updating Note"}`,
          );
          return of(null);
        }),
      )
      .subscribe();
  }
}
